/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ServicesInputs */

const en_services = /** @type {(inputs: ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const de_services = /** @type {(inputs: ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungen`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {ServicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const services = /** @type {((inputs?: ServicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ServicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_services(inputs)
	return en_services(inputs)
});